import { render, staticRenderFns } from "./TreeView.vue?vue&type=template&id=4651ba90&scoped=true&"
import script from "./TreeView.vue?vue&type=script&lang=js&"
export * from "./TreeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4651ba90",
  null
  
)

export default component.exports